import { Outlet, Link } from "react-router-dom";
import { DarkModeProvider } from '../DarkModeContext';
import DarkModeToggle from '../DarkModeToggle';
import { useState } from 'react';

function Layout() {

    document.title = "Samuel Weissenbacher"
    var item = "text-center m-auto flex-1 px-8 py-4 hover:bg-pink-800 hover:bg-opacity-30 hover:bg-white transition-all duration-200";
    const [isAlgoMenuOpen, setAlgoMenuOpen] = useState(false);
    return (
      <>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>
        <DarkModeProvider className="flex">
        <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">

          <div className= "sticky top-0 z-50">
          
          <div className=" text-white flex flex-wrap flex-row bg-gradient-to-r from-Template-0 to-Template-1">
            <div className="text-2xl px-4 my-auto font-serif">Samuel Weißenbacher</div>
            <div className="flex ml-auto place-content-end">
              <Link className={item} to="/">Homepage</Link>
              <Link className={item} to="/projects">Projekte</Link>
              <Link className={item} to="/books">Bücher</Link>
              <Link className={item} to="/python">SymPy</Link>
              
              <div className="relative">
                    <button
                      className={item}
                      onMouseEnter={() => setAlgoMenuOpen(true)}
                      onMouseLeave={() => setAlgoMenuOpen(false)}
                    >
                      Algorithmen
                    </button>
                    {isAlgoMenuOpen && (
                      <div
                        className="flex flex-col absolute  left-0 w-full bg-gradient-to-r from-Template-0 to-Template-1"
                        onMouseEnter={() => setAlgoMenuOpen(true)}
                        onMouseLeave={() => setAlgoMenuOpen(false)}
                      >
                        <Link className={item} to="/bubblesort">Bubblesort</Link>
                        <Link className={item} to="/quicksort">Quicksort</Link>
                        <Link className={item} to="/heapsort">Heapsort</Link>
                      </div>
                    )}
                  </div>

              <Link className={item} to="https://cloud.schmu.ddns.net/login">Cloud</Link>
              <DarkModeToggle/>
              </div></div>
            </div>
              <Outlet/>
          </div>
          <div>
          <div className="text-white flex flex-wrap flex-row bg-gradient-to-r from-Template-0 to-Template-1">
            <Link className={item} to="https://www.instagram.com/samuel.weissenbacher/"><div className="fa fa-instagram"/></Link>
            <Link className={item} to="https://gitlab.com/SamuelEliasW/projects_weis"><div className="fa fa-gitlab"/></Link>
            <div className={item}>samuel.weissenbacher@gmx.net</div>
          </div>  
        </div>
        </DarkModeProvider>
      </>
    );
  }
  
  export default Layout;
  